/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'eoc-changeboarding.wizard.steps.four.title-no-translate',
		defaultMessage: 'Ready to shift from Opsgenie?',
		description: 'Title of step four',
	},
	listDescription: {
		id: 'eoc-changeboarding.wizard.steps.four.list-description-no-translate',
		defaultMessage: 'Here’s a summary of what happens once you shift:',
		description: 'Description of list that contains what will happen after unlocking operations',
	},
	listItemOne: {
		id: 'eoc-changeboarding.wizard.steps.four.list-item-one-no-translate',
		defaultMessage:
			'Your Opsgenie data and settings will be synced with Jira Service Management, without any changes',
		description: 'List item that indicates that Opsgenie data will be copied without changes',
	},
	listItemTwo: {
		id: 'eoc-changeboarding.wizard.steps.four.list-item-two-no-translate',
		defaultMessage:
			'You’ll get a guide to follow and complete your shift from Opsgenie to Jira Service Management',
		description: 'List item that indicates that Opsgenie account will still be accessible',
	},
	listItemThree: {
		id: 'eoc-changeboarding.wizard.steps.four.list-item-three-no-translate',
		defaultMessage:
			'Your Opsgenie account will continue to be accessible, until it’s turned off on <b>{unlockDate}</b>',
		description: 'List item that indicates that you will get help to set up and get started',
	},
	learnMore: {
		id: 'eoc-changeboarding.wizard.steps.four.learn-more-no-translate',
		defaultMessage: 'Don’t feel ready yet? <link>Read more about operations</link>',
		description: 'Link to learn more about operations',
	},
});
